import './App.css';
import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import Dot from './Dot';
import ArrowLeft from './ArrowLeft';
import ArrowRight from './ArrowRight';
import Arrow from './Arrow';

const color = {
  secondary: 'rgba(109, 109, 101, 1)',
  default: 'rgba(232, 72, 42, 1)',
  smart: 'rgba(72, 48, 220, 1)',
  beautiful: 'rgba(238, 54, 128, 1)',
  joyful: 'rgba(255, 184, 48, 1)',
};

const page = [
  {id: 1, title: 'My Week', color: color.default},
  {id: 2, title: 'Smart', color: color.smart},
  {id: 3, title: 'Beautiful', color: color.beautiful},
  {id: 4, title: 'Joyful', color: color.joyful},
]

const extraPage = [
  {id: 5, title: 'Daruma', color: color.default},
  {id: 6, title: 'Contacts', color: color.default},
]

function Navigation( {handlePagination, currentPage, navigateBack, navigateForward} ) {

  const isMobile = useMediaQuery({ query: `(max-width: 1132px)` });

  const [isExpanded, setIsExpanded] = useState(false);
  const handleChangingState = () => {
    setIsExpanded(prev => !prev);
  }

  const [hovered, setHovered] = useState(null);

  const triggerPagination = (title, color) => {
    handlePagination(title, color);
    setIsExpanded(prev => !prev);
  }


  return (
    <div className='navigation' style={{height: isMobile ? isExpanded ? '100%' : '83px' : '100%',}}>
        <div className='controls-wrapper' style={{display: isMobile ? 'flex' : 'none'}}>
        <button className='arrow-wrapper' onClick={() => navigateBack()} disabled={currentPage === 'My Week' ? true : false} style={{cursor: currentPage === 'My Week' ? 'default' : 'pointer'}}><ArrowLeft style={{opacity: currentPage === 'My Week' ? '0.3' : '1'}} /></button>
        <button className='item current' onClick={() => handleChangingState()}>
          <p className='text main'>{currentPage}</p>
        </button>
        <button className='arrow-wrapper' onClick={() => navigateForward()} disabled={currentPage === 'Contacts' ? true : false} style={{cursor: currentPage === 'Contacts' ? 'default' : 'pointer'}}><ArrowRight style={{opacity: currentPage === 'Contacts' ? '0.3' : '1'}} /></button>
        </div>
          <div className='list-wrapper' style={{visibility: isMobile && !isExpanded ? 'hidden' : 'visible', opacity: isMobile && !isExpanded ? '0' : '1'}}>
            <ul className='list'>
              {page.map(page => (
                <button className='item' disabled={isMobile && page.title === currentPage ? true : false} style={{cursor: isMobile && page.title === currentPage ? 'default' : 'pointer'}} onMouseEnter={isMobile ? null  : () => setHovered(page.id)} onMouseLeave={isMobile ? null  : () => setHovered(null)} onClick={() => {triggerPagination(page.title, page.color)}}>
                <Dot opacity={isMobile ? '0' : page.title === currentPage ? '1' :  !isMobile && hovered === page.id ? '1' :  '0'} fill={page.color}/>
                <li className='text' style={{color: isMobile ? color.secondary : page.title === currentPage ? 'rgba(11, 11, 11, 1)' : !isMobile &&  hovered === page.id ? 'rgba(94, 94, 87, 1)' :  'rgba(109, 109, 101, 1)', textDecoration: isMobile && page.title === currentPage ? 'line-through' : 'none'}} key={page.id}> 
                  {page.title}
                </li>
                </button>
              ))}
            </ul>
            <ul className='list'>
              {extraPage.map(page => (
                <button className='item' disabled={isMobile && page.title === currentPage ? true : false} style={{cursor: isMobile && page.title === currentPage ? 'default' : 'pointer'}} onMouseEnter={isMobile ? null  : () => setHovered(page.id)} onMouseLeave={isMobile ? null  : () => setHovered(null)} onClick={() => {triggerPagination(page.title, page.color)}}>
                <Dot opacity={isMobile ? '0' : page.title === currentPage ? '1' :  !isMobile && hovered === page.id ? '1' :  '0'} fill={page.color}/>
                <li className='text' style={{color: isMobile ? color.secondary : page.title === currentPage ? 'rgba(11, 11, 11, 1)' :  !isMobile && hovered === page.id ? 'rgba(94, 94, 87, 1)' :  'rgba(109, 109, 101, 1)', textDecoration: isMobile && page.title === currentPage ? 'line-through' : 'none'}} key={page.id}> 
                  {page.title}
                </li>
                </button>
              ))}
            </ul>
      </div>
      <div className='line' />
    </div>
  );
}

export default Navigation